export default "__VITE_ASSET__079ffa84__"